import React, { useState, useEffect } from 'react';
import { makeStyles, Box, Typography, IconButton, Slider } from '@material-ui/core';
import { useTranslate, usePermissions, useDataProvider } from 'react-admin';
import icAttachment from '../assets/icons/ic_attachment.png';
import { isVideo, loadVideo, convertSecondToPlayTime } from '../utils';
import DialogChooseFile from '../file-management/file-management-dialog';
import { PrimaryButton } from '../common/button';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import { baseAuthUrl } from '../authProvider';
import ThumbnailIcon from './thumbnail';

const useStyles = makeStyles(() => ({
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    borderBrowse: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    btnAdd: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    btnIcon: {
        width: 14,
        height: 14
    },
    NameImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16.3px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    SizeImage: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12.2px',
        letterSpacing: 'normal',
        color: '#88898c',
    },
}));

function PlayMovie() {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const dispatch = useDispatch();

    const [value, setValue] = React.useState([0, 100]);
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { startTime, stopTime, file } = nodeSelected.applicationData.nodeApplication.movie;


    const handleChange = (_, newValue) => {
        if (file && file.length !== 0) {
            setValue(newValue);
            const newNode = {
                ...nodeSelected.applicationData,
                nodeApplication: {
                    ...nodeSelected.applicationData.nodeApplication,
                    movie: {
                        ...nodeSelected.applicationData.nodeApplication.movie,
                        startTime: newValue[0] * file.length / 100,
                        stopTime: newValue[1] * file.length / 100,
                    }
                }
            };
            dispatch(changeNodeGlobalData(newNode));
        }
    };

    const onRemoveMovie = () => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                movie: {
                    ...nodeSelected.applicationData.nodeApplication.movie,
                    file: null,
                    startTime: 0,
                    stopTime: 0
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 6,
            format: isVideo,
            setResponse: async (file) => {
                const video = await loadVideo(`${baseAuthUrl}/media/${file.fd}`);
                file.length = video ? Math.ceil(video.duration) : 0;
                setValue([0, 100]);

                const newNode = {
                    ...nodeSelected.applicationData,
                    nodeApplication: {
                        ...nodeSelected.applicationData.nodeApplication,
                        movie: {
                            ...nodeSelected.applicationData.nodeApplication.movie,
                            file,
                            startTime: 0,
                            stopTime: file.length
                        }
                    }
                };
                dispatch(changeNodeGlobalData(newNode));
            }
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }

    const getFile = () => {
        if (file) {
            dataProvider('GET_ONE', 'categories', {
                id: file.id
            }).then(({ data }) => {
                data.length = file.length
                if (data) {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        nodeApplication: {
                            ...nodeSelected.applicationData.nodeApplication,
                            movie: {
                                ...nodeSelected.applicationData.nodeApplication.movie,
                                file: data,
                            }
                        }
                    };
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
                else {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        nodeApplication: {
                            ...nodeSelected.applicationData.nodeApplication,
                            movie: {
                                startTime: 0,
                                stopTime: 0
                            }
                        }
                    };
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            });
        }
    }

    useEffect(() => {
        if (file) {
            const startPercent = startTime / file.length * 100;
            const stopPercent = stopTime / file.length * 100;
            setValue([startPercent, stopPercent]);
        }
    }, [startTime, stopTime]);

    useEffect(() => {
        getFile();
    }, [])

    if (!loaded) return null
    return (
        <Box >
            <Box mt={3.5}>
                <Box className={classes.borderBrowse} justifyContent='center' alignItems="center" >
                    <Box display='flex' width="100%" alignItems="center">
                        <Box mx={2} display='flex' alignItems="center">
                            <IconButton
                                variant="outlined"
                                color='primary'
                                style={{ marginRight: '10px', padding: 'unset' }}
                            >
                                <img alt='' src={icAttachment} width={27} />
                            </IconButton>
                            <Typography className={classes.Title}>{translate('resources.infoPage.playMovie.movie')}</Typography>
                        </Box>
                        <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                            <PrimaryButton
                                disabled={!isEditing}
                                label={file ? translate('pos.common.change') : translate('pos.common.browse')}
                                onClick={handleOpenFileDialog}
                            />
                            <DialogChooseFile
                                formats={openFile.format}
                                defaultId={openFile.defaultId}
                                open={openFile.status}
                                pickerMode='pickMediaOnly'
                                handleClose={handleClose}
                                setChooseValue={openFile.setResponse}
                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                            />
                        </Box>
                    </Box>
                    <ThumbnailIcon
                        thumbnail={file}
                        onClear={onRemoveMovie}
                    />
                </Box>
                <Box>
                    <Slider
                        style={{ width: 500 }}
                        value={value}
                        onChange={handleChange}
                        valueLabelDisplay="off"
                    />
                </Box>

                <Box style={{ marginTop: 20 }}>
                    <Typography className={classes.Title}>{translate('pos.common.start')}</Typography>
                    <input value={convertSecondToPlayTime(Math.floor(startTime))} type='text' disabled />
                </Box>
                <Box style={{ marginTop: 20 }}>
                    <Typography className={classes.Title}>{translate('pos.common.stop')}</Typography>
                    <input value={convertSecondToPlayTime(Math.floor(stopTime))} type='text' disabled />
                </Box>
            </Box>
        </Box>
    )
}

export default PlayMovie;
